import type { UrnProduct } from "./types";

export function canEngraveUrn(
  urn: Pick<UrnProduct, "engravable"> | null | undefined,
): boolean {
  if (!urn) return false;
  return urn.engravable === true;
}
